// extracted by mini-css-extract-plugin
export default {"privacyPolicy-view":"index_privacyPolicy-view__diXP8"};